import styled from "styled-components";
import { borders, colors, zIndex } from "@sonder/ui/source/styled/theme";

export type DropdownContentAlignment = "left" | "right" | "center";

export interface DropdownContentProps {
  align?: DropdownContentAlignment;
}
export const DropdownContent = styled.div<DropdownContentProps>`
  background: ${colors.white};
  border: ${borders.standard};
  border-radius: 0.3rem;
  box-sizing: border-box;
  display: flex;
  max-width: 100vw;
  max-height: 100vw;
  position: absolute;
  z-index: ${zIndex.dropDown};
`;
